export function animateScrollLeft(element, toValue, duration, callback) {
  var startValue = element.scrollLeft;
  var startTime = Date.now();

  (function loop() {
    var currentTime = Date.now();
    var progress = Math.min((currentTime - startTime) / duration, 1);
    element.scrollLeft = startValue + (toValue - startValue) * progress;

    if (progress < 1) {
      requestAnimationFrame(loop);
    } else {
      if (callback) {
        callback();
      }
    }
  })();
}

export function scrollLeft(element, left, behavior) {
  // add support for older browsers
  const supportsNativeSmoothScroll =
    "scrollBehavior" in document.documentElement.style;

  if (supportsNativeSmoothScroll) {
    element.scrollTo({
      left,
      behavior,
    });
  } else {
    element.style.scrollBehavior = behavior;
    animateScrollLeft(element, left, 400, () => {
      element.style.scrollBehavior = "";
    });
  }
}

export function useInteractionTracker(
  events = ["click", "mousemove", "keydown", "scroll"]
) {
  let callback = () => {};

  const clear = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, handler);
    });
  };

  const listen = (fn) => {
    callback = fn;
    events.forEach((eventName) => {
      window.addEventListener(eventName, handler);
    });
  };

  const handler = () => {
    callback();
    clear();
  };

  return {
    listen,
    clear,
  };
}

export function createDOMElement(tagName, attributes = {}, target = null) {
    if (
      typeof tagName !== "string" ||
      typeof attributes !== "object" ||
      (target !== null && !(target instanceof HTMLElement))
    ) {
      throw Error("Invalid parameters for createDOMElement function");
    }
  
    const element = document.createElement(tagName);
  
    Object.entries(attributes).forEach(([key, value]) =>
      element.setAttribute(key, value)
    );
  
    if (target instanceof HTMLElement) {
      try {
        target.appendChild(element);
      } catch (error) {
        console.error("Could not append element to target", error);
      }
    }
  
    return element;
  }

const sleep = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs));
const timeout = (delayMs) => new Promise((_, reject) => setTimeout(reject, delayMs));

export const waitForCondition = (fn, delay = 100, timeoutMs = 2000 ) => {
  return Promise.race([
    new Promise(async (resolve, reject) => {
      const startTime = Date.now();
      while (!fn()) {
        if (Date.now() - startTime >= timeoutMs) {
          reject(new Error('Maximum retries exceeded'));
          return;
        }

        await sleep(delay);
        delay *= 2; // Exponential backoff
      }
      resolve();
    }),
    timeout(timeoutMs),
  ])
};
